import constant from "../../constant";
import router from "../../router";
const api = constant.api + "settings";
// initial state
const state = () => ({
  all: [],
  settings: [],
  setting: {},
});

// getters
const getters = {
  getAll: (state) => {
    return state.all;
  },
  getSetting: (state) => {
    return state.setting;
  },

  getSettings: (state) => {
    return state.settings;
  },
};

// actions
const actions = {
  async getAll({ commit, dispatch, rootState }) {
    try {
      const response = await this.$api.show(api);
      // Handle new response format with status/data or old format
      const settings = (response.data && response.data.data) ? response.data.data : (response.data || []);
      commit("setSettings", settings);
      // Sync with auth module settings
      if (rootState && rootState.auth) {
        commit("auth/SET_SETTINGS", settings, { root: true });
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
      dispatch("notification/store", {
        status: "error",
        message: "Erreur lors du chargement des paramètres.",
      }, { root: true });
      throw error;
    }
  },
  async show({ commit, dispatch }, reference) {
    try {
      const response = await this.$api.show(api + "/" + reference);
      // Handle new response format with status/data or old format
      const setting = (response.data && response.data.data) ? response.data.data : (response.data || {});
      commit("setSetting", setting);
    } catch (error) {
      console.error("Error fetching setting:", error);
      dispatch("notification/store", {
        status: "error",
        message: "Erreur lors du chargement du paramètre.",
      }, { root: true });
      throw error;
    }
  },

  async store({ commit, dispatch, rootState }, data) {
    try {
      const response = await this.$api.create(api, data, { confirm: false });
      const message = response.data && response.data.message ? response.data.message : "Paramètre créé avec succès.";
      const status = response.data && response.data.status ? response.data.status : "success";
      
      dispatch("notification/store", { status, message }, { root: true });
      
      if (status === "success") {
        // Reload settings to sync with auth module
        await dispatch("getAll");
        router.push({ name: "settings-index" });
      }
    } catch (error) {
      // Error is handled by axios interceptor and component
      throw error;
    }
  },
 
  async update({ dispatch }, data) {
    try {
      const response = await this.$api.update(api + "/" + data.reference, data, { confirm: false });
      const message = response.data && response.data.message ? response.data.message : "Paramètre mis à jour avec succès.";
      const status = response.data && response.data.status ? response.data.status : "success";
      
      dispatch("notification/store", { status, message }, { root: true });

      if (status === "success") {
        // Reload settings to sync with auth module
        await dispatch("getAll");
        router.push({
          name: "settings-index",
        });
      }
    } catch (error) {
      // Error is handled by axios interceptor and component
      throw error;
    }
  },

  async destroy({ commit, dispatch }, reference) {
    try {
      const response = await this.$api.delete(api + "/" + reference, { confirm: false });
      const message = response.data && response.data.message ? response.data.message : "Paramètre supprimé avec succès.";
      const status = response.data && response.data.status ? response.data.status : "success";
      const settings = response.data && response.data.data ? response.data.data : [];
      
      dispatch("notification/store", { status, message }, { root: true });
      
      if (status === "success") {
        commit("setSettings", settings);
        // Sync with auth module settings
        if (rootState && rootState.auth) {
          commit("auth/SET_SETTINGS", settings, { root: true });
        }
      }
    } catch (error) {
      // Error is handled by axios interceptor
      throw error;
    }
  },

  async seedDefaults({ commit, dispatch, rootState }) {
    try {
      const response = await this.$api.create(api + "/seed-defaults", {}, { confirm: false });
      const message = response.data && response.data.message ? response.data.message : "Paramètres par défaut installés avec succès.";
      const status = response.data && response.data.status ? response.data.status : "success";
      const settings = response.data && response.data.data ? response.data.data : [];
      
      dispatch("notification/store", { status, message }, { root: true });
      
      if (status === "success") {
        commit("setSettings", settings);
        // Sync with auth module settings
        if (rootState && rootState.auth) {
          commit("auth/SET_SETTINGS", settings, { root: true });
        }
      }
    } catch (error) {
      console.error("Error seeding default settings:", error);
      dispatch("notification/store", {
        status: "error",
        message: "Erreur lors de l'installation des paramètres par défaut.",
      }, { root: true });
      throw error;
    }
  },
};

// mutations
const mutations = {
  setSettings(state, settings) {
    state.all = settings;
    state.settings = settings;
  },
  setSetting(state, setting) {
    state.setting = setting;
  },
  
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
